import formatter from "@/utils/formatter";

export const parseColValue = (column, value) => {
  if (!column.format) {
    return value;
  }

  value = formatter.format(value, column.format);

  return value;
};

export default {
  name: "TgTableSlot",
  functional: true,
  inject: ["tableRoot"],
  props: {
    row: Object,
    index: Number,
    parentCol: Object,
    column: {
      type: Object,
      default: null,
    },
    value: [String, Number],
  },
  render: (h, ctx) => {
    let root = ctx.injections.tableRoot;
    
    let value =
      ctx.props.row && ctx.props.column.name in ctx.props.row
        ? ctx.props.row[ctx.props.column.name]
        : "";

    if (value == null || typeof value === "undefined" || value.length == 0) {
      value = ctx.props.column.default;
    }

    if (!root || !root.$scopedSlots[ctx.props.column.slot]) {
      return h("div");
    }

    return h(
      "div",
      root.$scopedSlots[ctx.props.column.slot]({
        row: ctx.props.row,
        column: ctx.props.column,
        index: ctx.props.index,
        value: value,
        formated: parseColValue(ctx.props.column, value),
      })
    );
  },
};
